import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import moduleCompany from "@/store/company/moduleCompany.js";
import TimeCalendar from "@/components/shared/TimeCalendar.vue";
import VehicleAssignedList from "@/components/vehicle/list/VehicleAssignedList.vue";
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";
import DateUtils from "@/helpers/DateUtils.js";
import Hourly from "@/components/shared/Hourly.vue";
import Minute from "@/components/shared/Minute.vue";
import Monthly from "@/components/shared/Monthly.vue";
import DayWeek from "@/components/shared/DayWeek.vue";
import DayMonth from "@/components/shared/DayMonth.vue";

const KEY_BACKSPACE = "Backspace";
const KEY_ENTER = "Enter";
const KEY_TAB = "Tab";
export const generalPurposeMixin = {
	components: {
		Monthly,
		Hourly,
		Minute,
		DayWeek,
		DayMonth,
		TimeCalendar,
		VehicleAssignedList,
	},
	props: {
		duration: {
			type: String,
			default: "",
		},
		showDate: null,
	},
	data() {
		return {
			hours: 12,
			minutes: 0,
			seconds: 0,
			renderComponentJob: 0,
		};
	},
	created() {
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
	},
	watch: {
		minutes(val) {
			if (val > 59) {
				this.minutes = 59;
			} else if (val === "00") {
				this.minutes = 0;
			} else if (val === "0" || val === null || val === "") {
				this.minutes = val;
			} else if (val.length > 1) {
				this.minutes = val.replace(/^0+/, "");
			}
		},
		seconds(val) {
			if (val > 59) {
				this.seconds = 59;
			} else if (val === "00") {
				this.seconds = 0;
			} else if (val === "0" || val === null || val === "") {
				this.seconds = val;
			} else if (val.length > 1) {
				this.seconds = val.replace(/^0+/, "");
			}
		},
		hours(val) {
			if (val === "00") {
				this.hours = 0;
			} else if (val === "0" || val === null || val === "") {
				this.hours = val;
			} else if (val.length > 1) {
				this.hours = val.replace(/^0+/, "");
			}
		},
	},
	computed: {
		getPoliticalDivision() {
			const countryInfo = {
				ARGENTINA: {department: this.$t("Province"), city: this.$t("Municipality")},
				BRASIL: {department: this.$t("State"), city: this.$t("City")},
				CHILE: {department: this.$t("Region"), city: this.$t("Commune")},
				COLOMBIA: {department: this.$t("Department"), city: this.$t("City")},
				COSTA_RICA: {department: this.$t("Province"), city: this.$t("Canton")},
				ECUADOR: {department: this.$t("Province"), city: this.$t("Canton")},
				GUATEMALA: {department: this.$t("Department"), city: this.$t("Municipality")},
				MEXICO: {department: this.$t("State"), city: this.$t("Municipality")},
				PARAGUAY: {department: this.$t("Department"), city: this.$t("District")},
				PERU: {department: this.$t("Region"), city: this.$t("Province")},
			};
			let normalizedCountry = "";
			if (this.selectedCountry != null && typeof this.selectedCountry === "object") {
				if (this.selectedCountry.value != null && this.selectedCountry.value !== undefined) {
					normalizedCountry = this.selectedCountry.value.toUpperCase().replace(" ", "_");
				}
			}
			const selectedCountryInfo = countryInfo[normalizedCountry];
			if (!selectedCountryInfo) {
				return countryInfo["COLOMBIA"];
			}
			return selectedCountryInfo;
		},
		getDaysInRange() {
			return (rangeDate, timeRange) => {
				const {startDate, endDate} = rangeDate;
				const {start, end} = timeRange;
				const startDateTime = new Date(`${startDate.split("T")[0]}T${start}`);
				const endDateTime = new Date(`${endDate.split("T")[0]}T${end}`);
				if (!startDateTime || !endDateTime) {
					return null;
				}
				let seconds = Math.floor((endDateTime - startDateTime) / 1000);
				let negative = false;
				if (seconds < 0) {
					seconds = Math.abs(seconds);
					negative = true;
				}
				const hours = Math.floor(seconds / 3600);
				seconds %= 3600;
				const minutes = Math.floor(seconds / 60);
				seconds %= 60;
				const sign = negative ? "-" : "";
				const totalTime = `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(
					2,
					"0"
				)}:${String(seconds).padStart(2, "0")}`;
				return totalTime;
			};
		},
		dateInitComputed: {
			get() {
				const date = new Date(this.showDate);
				date.setMonth(date.getMonth() - 1);
				date.setDate(15);
				return DateUtils.toDefaultDateTime(date, "YYYY-MM-DD");
			},
			set(val) {},
		},
		dateFinalComputed: {
			get() {
				// Convertir `dateInitComputed` en un objeto de fecha
				const initialDate = new Date(this.dateInitComputed);
				// Obtener el mes siguiente
				const nextMonth = initialDate.getMonth() + 2;
				// Crear una nueva fecha establecida para el día 15 del próximo mes
				const finalDate = new Date(initialDate.getFullYear(), nextMonth, 15);
				// Devolver la fecha final en el formato "YYYY-MM-DD"
				return DateUtils.toDefaultDateTime(finalDate, "YYYY-MM-DD");
			},
			set(val) {},
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		goRouter(name) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("IfYouExitNowAndYouHaveUnsavedData"),
				accept: () => {
					this.$router.push({name: `${name}`});
				},
				acceptText: this.$t("Routing.ValidateMessages.Yes"),
				cancelText: this.$t("Routing.ValidateMessages.Not"),
			});
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		isCharNumeric(charStr) {
			return /\d/.test(charStr);
		},
		isKeyPressedNumeric(event) {
			const charStr = event.key;
			return this.isCharNumeric(charStr);
		},
		finishedEditingPressed(event) {
			const key = event.key;
			return key === KEY_ENTER || key === KEY_TAB;
		},
		isBackspace(event) {
			return event.key === KEY_BACKSPACE;
		},
		isLeftOrRight(event) {
			return ["ArrowLeft", "ArrowRight"].indexOf(event.key) > -1;
		},
		onKeyDown(event, val) {
			if (this.isLeftOrRight(event) || this.isBackspace(event)) {
				event.stopPropagation();
				return;
			}
			if (!this.finishedEditingPressed(event) && !this.isKeyPressedNumeric(event)) {
				if (event.preventDefault) event.preventDefault();
			}
		},
	},
};
